<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    :show-close="false"
    :modal-append-to-body="false"
    width="400px"
    center
  >
    <p>{{ $t('Audiences_SegmentEvaluations_FatalDialog_Message') }}</p>

    <span slot="footer" class="dialog-footer">
      <el-button type="danger" plain @click="ok">
        {{ $t('Audiences_SegmentEvaluations_FatalDialog_Ok') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { EventBus } from '@/core/EventBus'

export default {
  name: 'FatalDialog',
  methods: {
    ok() {
      EventBus.$emit('fatal-ok')
    }
  }
}
</script>

<style scoped>
p {
  font-size: 16px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/components/FatalDialog.vue